import { decodeCookie } from "../utils/decodeCookie";
import { apiClient, config, multiPartConfig } from "./env";
import { toast } from "react-hot-toast";

// Extract the domain from the current window location
const extractDomain = () => {
  const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
  if (domain !== "members.tripmerchant.com") {
    const parts = domain.split(".");
    const subDomain = parts[0] === "www" ? parts[1] : parts[0];
    if (subDomain && subDomain !== "tripmerchant" && subDomain !== "localhost:3001") {
      return subDomain;
    }
  }
  return "trip"; // Default domain
};

const mainDomain = extractDomain();

export default {
  any: async (api, params, data) => {

    let token = null 
      if(mainDomain == 'tripbuilder'){
         token = decodeCookie('tripbuilder').slice(1);
      }else {
         token = decodeCookie(
          process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY
        ).slice(1);
        
      }

    if (token && api.useAuth) {
      if (data instanceof FormData) {
        apiClient.setHeaders((await multiPartConfig()).headers);
      } else {
        apiClient.setHeaders((await config()).headers);
      }
    }
    const response = await apiClient.any({
      method: api.method,
      url: api.url,
      params: { ...params, domain: mainDomain }, // Add domain to params
      data: data,
    });

    if (response.status === 401) {
      console.log("Session expired, login again");
      return 401;
    }
    
    if (response?.data?.status === 409) {
      toast.dismiss();
      toast.error(response?.data?.error[0]);
    }

    if (response.ok) {
      if (response.data?.message && api.method !== "GET")
        console.log(response.data.message);
      return response.data;
    }

    if (response?.data?.errors) {
      const { errors } = response.data;
      let error = Object.keys(errors)[0];
      console.log({ error }, response.data?.errors);
      toast.dismiss();
      toast.error(
        response.data?.message
          ? response.data.message
          : response.data?.errors || error
      );
      return -1;
    }

    if (!response.ok && response.data?.message) {
      console.log(response.data.message);
      return -1;
    }
  },
};
